// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"23":"73452c52","136":"12f3e76d","462":"ff641110"}[chunkId] + ".js";
};